<template>
  <div class="component-form-button">
    <span
      v-if="showMsg"
      class="required-message"
    ><span>*</span>为必填信息</span>
    <a-button
      :loading="btnIsLoading"
      class="save-button"
      :disabled="submitIsDisabled"
      type="primary"
      shape="round"
      @click="$emit('onSubmit')"
    >
      {{ submitText }}
    </a-button>
    <a-button

      :disabled="cancelIsDisabled"
      class="cancel-button"
      shape="round"
      @click="$emit('onCancel')"
    >
      {{ cancelText }}
    </a-button>
  </div>
</template>
<script>
export default {
  props: {
    submitText: {
      default: '保存',
    },
    cancelText: {
      default: '取消',
    },
    submitIsDisabled: {
      default: false,
    },
    cancelIsDisabled: {
      default: false,
    },
    showMsg: {
      default: true,
    },
    btnIsLoading: {
      type: Boolean,
    },
  },
};
</script>
<style lang="scss" scoped>
.component-form-button {
  height: 80px;
  line-height: 80px;
  background: #f9f9fc;
 margin: 0px -24px;
    padding: 0 20px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  .required-message {
    span {
      color: #ff5075;
      display: inline-block;
      width: 9px;
    }
  }
  .save-button {
    float: right;
    margin-left: 10px;
    margin-top: 20px;
    width: 104px;
  }
  .cancel-button {
    float: right;
    margin-left: 10px;
    margin-top: 20px;
    width: 104px;
  }
}
</style>
